import { gql } from '@apollo/client';

export default gql`
  mutation userDeleteConfirm($token: String!) {
    userDeleteConfirm(input: { token: $token }) {
      success
    }
  }
`;
